module.exports = __webpack_public_path__ + "img/playback-speed.d945e05e.svg";